import * as React from 'react'

const IconReset = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-reset_svg__a' d='M0 0h19.993v21.816H0z' />
    </defs>
    <g transform='translate(2 1)' fill='none' fillRule='evenodd'>
      <mask id='icon-reset_svg__b' fill='#fff'>
        <use xlinkHref='#icon-reset_svg__a' />
      </mask>
      <path
        d='M15.704 3.602a1.5 1.5 0 0 0-1.713 2.463 7.009 7.009 0 0 1 1.753 9.744 6.954 6.954 0 0 1-4.509 2.894A6.95 6.95 0 0 1 6 17.56c-3.169-2.202-3.955-6.573-1.752-9.742a6.932 6.932 0 0 1 2.116-1.966l-.295.666a1.5 1.5 0 1 0 2.742 1.216l1.727-3.898a1.499 1.499 0 0 0-.763-1.979L5.878.13a1.5 1.5 0 1 0-1.216 2.742l.47.21a9.9 9.9 0 0 0-3.347 3.023c-3.147 4.528-2.024 10.772 2.503 13.92a9.93 9.93 0 0 0 7.478 1.63 9.932 9.932 0 0 0 6.441-4.135c3.147-4.527 2.024-10.77-2.503-13.918'
        fill='#00B2E3'
        mask='url(#icon-reset_svg__b)'
      />
    </g>
  </svg>
)

export default IconReset
